export default __webpack_public_path__ + "static/media/fox.69f613ce.png";